export enum BankAccountType {
    CHECKING = 'Checking',
    SAVINGS = 'Savings'
}